import { render, staticRenderFns } from "./AuthoriseSubletOld.vue?vue&type=template&id=a2f1bcb4"
import script from "./AuthoriseSubletOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseSubletOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports